module.exports = __webpack_public_path__ + "img/loader5.89288dc0.svg";